export const UPDATE_PATIENT_ACTION = 'UPDATE_PATIENT_ACTION';

export const updatePatient = (payload:any) => ({
        type: UPDATE_PATIENT_ACTION,
        ...payload
    }
);